import React from "react";
import ReactECharts from "echarts-for-react";

const ProsumerDashboardLineChart = ({
  color = "#1976d2",
  usageData,
}: {
  color?: string;
  usageData: (number | string)[];
}) => {
  const days = ["Thu", "Fri", "Sat", "Sun", "Mon", "Tue", "Wed"];

  const options = {
    xAxis: {
      type: "category",
      data: days,
      axisLabel: {
        color: "#181B25",
        fontSize: 11,
        fontWeight: 400,
      },
    },
    yAxis: {
      type: "value",
      name: "kWh",
      nameLocation: "end",
      nameTextStyle: {
        fontSize: 12,
        color: "#5F6368",
        padding: [0, 0, 10, 0],
      },
      axisLabel: {
        formatter: "{value}",
        color: "#5F6368",
        fontSize: 9,
        fontWeight: 400,
        lineHeight: 11,
        letterSpacing: 0.2,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#e0e0e0",
          type: "dashed",
        },
      },
      max: 120,
      interval: 30,
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
        fontSize: 12,
      },
      formatter: (params: any) => {
        const [data] = params;
        return `<div style="padding: 5px;">
          <strong>${data.axisValue}</strong><br/>
          Usage: ${data.data} kWh
        </div>`;
      },
    },
    grid: {
      left: "5%",
      right: "5%",
      bottom: "10%",
      containLabel: true,
    },
    legend: {
      data: [
        {
          name: "Usage",
        },
      ],
      top: "5%",
      right: "5%",
      textStyle: {
        fontSize: 12,
        color: "#5F6368",
      },
    },
    series: [
      {
        name: "Usage",
        data: usageData,
        type: "line",
        smooth: true,
        lineStyle: {
          color: color,
          width: 2,
        },
        itemStyle: {
          color: color,
        },
        symbol: "circle",
        symbolSize: 6,
      },
    ],
  };

  return (
    <ReactECharts option={options} style={{ height: "400px", width: "100%" }} />
  );
};

export default ProsumerDashboardLineChart;
